import React, {useEffect, useState} from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
import {FormattedMessage, useIntl} from "react-intl";
import CancelButton from "../../../../../components/buttons/CancelButton";
import FormFieldText from "../../../../../components/FormFieldText";
import SaveButton from "../../../../../components/buttons/SaveButton";
import {useConfirm} from "material-ui-confirm";

export type InputCardDialogProps = {
    onCancel: () => void;
    onOk: (value: string) => void;
    open: boolean;
    accessCardNumber: string
};

const InputCardDialog: React.FC<InputCardDialogProps> = (props) => {
    const intl = useIntl();

    const confirm = useConfirm();

    const [cardNumber, setCardNumber] = useState('');

    useEffect(() => {
        if (props.open) {
            setCardNumber("");
        }
    }, [props.open]);

    const handleOk = () => {
        if (cardNumber) {
            if (props.accessCardNumber !== cardNumber) {
                confirm({title: intl.formatMessage({id: 'VMS_REQUEST_VISITOR_CHECKOUT_CARD_NUMBER_DIFFERENT'})})
                    .then(() => {
                        props.onOk(cardNumber);
                    })
                    .catch(() => {
                        console.log("cancel")
                    });
            } else {
                props.onOk(cardNumber);
            }
        }
    };

    const handleCancel = () => {
        props.onCancel();
    }

    return (
        <Dialog open={props.open} onClose={handleCancel} fullWidth={true}>
            <DialogTitle>
                <FormattedMessage id={'VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER_PLACEHOLDER'}/>
            </DialogTitle>
            <DialogContent>
                <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER"})}
                               required={true}
                               autoFocus={true}
                               value={cardNumber}
                               onChange={(value) => {
                                   setCardNumber(value)
                               }}/>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={handleCancel}/>
                <SaveButton onClick={handleOk}/>
            </DialogActions>
        </Dialog>
    );
};

export default InputCardDialog;